import { render, staticRenderFns } from "./UsuariosKeycloakIndex.vue?vue&type=template&id=35990bc2&"
import script from "./UsuariosKeycloakIndex.vue?vue&type=script&lang=js&"
export * from "./UsuariosKeycloakIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports